<template>
  <div class="col-12 nopads">
    <infra-map-filter
      ref="filters"
      @types-selected="updateFilters"
    />
    <storm-sewers-map
      ref="sewers"
      :map="map"
      :filters="filters"
      :bounding-box="boundingBox"
      :selected-contract-ids="selectedContractIds"
      :user="user"
    />
    <road-sign-map
      v-if="roadSignsEnabled"
      ref="roadSigns"
      :selected-contract-ids="selectedContractIds"
      :map="map"
      :bounding-box="boundingBox"
      :user="user"
      :coordinate="signCoordinate"
      :road-sign="selectedSign"
      :selected-items="selectedSigns"
    />
    <street-light-map
      v-if="streetLightsEnabled"
      ref="streetLightMap"
      :bounding-box="boundingBox"
      :map="map"
      :selected-contract-id="selectedContractId"
      :selected-contract-ids="selectedContractIds"
    />
    <bridge-map
        v-if="bridgesEnabled"
        ref="bridges"
        :bounding-box="boundingBox"
        :map="map"
        @startInspection="startInspection"/>
    <mixed-waste-bins-map
        v-if="mixedWasteBinsEnabled"
        ref="mixedWasteBinsMap"
        :bounding-box="boundingBox"
        :map="map"
        :selected-contract="selectedContractId"
        :selected-contract-ids="selectedContractIds"
    />
    <div
      v-if="loading > 0"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {timeUtils} from '@/components/mixins/TimeUtils'
import {mapHelper} from '@/components/mixins/MapMixin'
import {stormSewersMixin} from "@/components/mixins/StormSewersMixin";
import {roadSignHelper} from "@/components/mixins/RoadSignMixin";
import {restApi} from '@/components/mixins/RestApiMixin'
import {geometryMixin} from "@/components/mixins/GeometryMixin";
import StormSewersMap from "@/components/stormsewers/StormSewersMap";
import InfraMapFilter from "@/components/infra/InfraMapFilter";
import RoadSignMap from "@/components/roadsign/RoadSignMap";
import StreetLightMap from "@/components/streetlights/StreetLightMap";
import BridgeMap from "../bridge/BridgeMap.vue";
import MixedWasteBinsMap from "@/components/mixedwastebins/MixedWasteBinsMap";

export default {
    name: 'InfraMap',
    components: {
        BridgeMap,
        StreetLightMap,
        RoadSignMap,
        StormSewersMap,
        MixedWasteBinsMap,
        InfraMapFilter,
    },
    mixins: [timeUtils, mapHelper, restApi, geometryMixin, stormSewersMixin, roadSignHelper],
    props: {
        map: {
            type: Object,
            default: null
        },
        mapSettings: {
            type: Object,
            default: null
        },
        boundingBox: {
            type: Array,
            default() {
                return []
            }
        },
        selectedContractId: {
            type: Number,
            default: null
        },
        selectedContractIds: {
            type: Array,
            default() {
                return []
            }
        },
        user: {
            type: Object,
            default: null
        },
        signCoordinate: {
            type: Object,
            default: null
        },
        selectedSign: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: 0,
            filters: [],
            selectedSigns: [],
            streetLightsEnabled: false,
            roadSignsEnabled: false,
            bridgesEnabled: false,
            mixedWasteBinsEnabled: false,
        }
    },
    watch: {
       signCoordinate: function () {
           if (this.signCoordinate) {
               this.$refs.filters.toggleFilter(this.TRAFFIC_SIGN, true)
               this.roadSignsEnabled = true
           }
       }
    },
    mounted() {
        // Restore state from map settings?
        if (this.signCoordinate) {
            this.$refs.filters.toggleFilter(this.TRAFFIC_SIGN, true)
            this.roadSignsEnabled = true
        }
    },
    beforeUnmount() {
        this.hideAll()
    },
    methods: {
        isVisible(type) {
            let pref = this.filters.find(item => item === type)
            return pref !== undefined
        },

        updateFilters(filters) {
            this.filters = filters
            this.streetLightsEnabled = filters.find(item => item === this.STREET_LIGHT)
            this.roadSignsEnabled = filters.find(item => item === this.TRAFFIC_SIGN)
            this.bridgesEnabled  = filters.find(item => item === this.BRIDGE)
            this.mixedWasteBinsEnabled = filters.find(item => item === this.MIXED_WASTE_BINS)
            this.$emit('filtersChanged', this.filters)
        },

        hideAll() {
            if (this.$refs.sewers) {
                this.$refs.sewers.hideAll()
            }
            if (this.$refs.streetLightMap) {
                this.$refs.streetLightMap.hideAll()
            }
            if (this.$refs.roadSigns) {
                this.$refs.roadSigns.hideSigns()
            }
            if (this.$refs.bridges) {
                this.$refs.bridges.hideBridges()
            }
        },

        getSewerLines() {
            return this.$refs.sewers ? this.$refs.sewers.getSewerLines() : []
        },

        getSewerDrains() {
            return this.$refs.sewers ? this.$refs.sewers.getSewerDrains() : []
        },

        getVisibleSigns() {
            return this.$refs.roadSigns ? this.$refs.roadSigns.getVisibleSigns() : []
        },

        getVisibleMixedWasteBins() {
            return this.$refs.mixedWasteBinsMap ? this.$refs.mixedWasteBinsMap.getVisibleMixedWasteBins() : []
        },

        getStreetLights() {
            return this.$refs.streetLightMap ? this.$refs.streetLightMap.getStreetLights() : []
        },

        addPowerStation(coords) {
            this.streetLightsEnabled = true
            this.$nextTick(() => this.$refs.streetLightMap.addPowerStation(coords))
        },

        addStreetLight(coords) {
            this.streetLightsEnabled = true
            this.$nextTick(() => this.$refs.streetLightMap.addStreetLight(coords))
        },

        addDrain(coords) {
            this.$refs.sewers.newDrain(coords)
        },

        startInspection(item) {
            this.$emit('startInspection', 'bridge', item)
        },

        editSign(sign) {
            this.$refs.roadSigns.editSign(sign)
        },

        signsSelected(selection) {
            this.selectedSigns = selection
        },

        addSewerLine(coords) {
            this.$refs.sewers.addSewerLine(coords)
        },

        addCable(coords) {
            this.$refs.streetLightMap.addCable(coords)
        }
    }
}
</script>
